<template>
  <div>
    <div class="row" v-if="loading">
      <div class="page-content-state page-content-state-loading col-12">
        <span class="page-content-state__icon  far fa-spinner-third fa-spin"></span>
        <div class="page-content-state__content">Generating plan link</div>
      </div>
    </div>
    <div class="row" v-else-if="error">
      <div class="page-content-state col-12">
        <span class="page-content-state__icon fal fa-sad-cry"></span>
        <div class="page-content-state__header">Sorry, there was a problem generating the plan link</div>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col-lg-6">
        <p>You can share your plan by selecting the Email Link button, or alternatively you can copy the link and store it so you can access the plan later.</p>
        <br />
        <p>Note: The link for the shared plan will expire in 18 months.</p>
      </div>
      <div class="col-lg-6">
        <div class="form-group mb-0">
          <label>Copy Link <i class="fa fa-info-circle" id="tooltip-copy-link"></i></label>
          <div class="input-group">
            <input type="text" id="copy-link" class="form-control" aria-label="Copy Link"
              v-on:focus="$event.target.select()"
              ref="copyLinkUrl"
              :value="this.getBaseUrl + 'saved-plan?id='+ this.id"
              aria-describedby="copy-link" />
            <div class="input-group-append">
              <button @click="copyLink" class="input-group-text"><i class="fa fa-copy"></i></button>
            </div>
            <b-tooltip target="tooltip-copy-link" triggers="hover" placement="top">
              This is a static link to your course plan.<br />Student notes are not saved using this method.
            </b-tooltip>
          </div>
        </div>

        <div class="text-center"><strong>OR</strong></div>
        <button class="mt-3 btn btn-primary w-100" @click="sendEmailLink()"><i class="fa fa-envelope"></i> Email Link</button>
      </div>
    </div>

  </div>
</template>

<style scoped lang="scss"></style>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  props: ['plan'],
  data() {
    return {
      loading: true,
      error: false,
      id: null,
      emailLink: null
    }
  },
  computed: {
    ...mapGetters({
      getBasePath: 'global/getBaseUrl',
      getStudentNotes: 'plans/getStudentNotes'
    }),
    studentNotes() {
      return this.getStudentNotes
    },
    getBaseUrl() {
      let url = new URL(this.getBasePath + '/', window.location.origin)
      return url
    }
  },
  methods: {
    ...mapActions({
      storeCoursePlan: 'savedCourse/storeCoursePlan'
    }),
    sendEmailLink() {
      window.location = `mailto:?subject=Murdoch Course Plan&body=Hello,

Please find the link to your generated course plan below.

Course Visualiser Link:
  ${this.emailLink}

${this.studentNotes && this.studentNotes.trim().length? 'Student Notes:%0D%0A'+encodeURIComponent(this.studentNotes.trim())+'%0D%0A%0D%0A' : ''}Disclaimer:
 • The link for the shared plan will expire in 18 months.
 • The Course Visualiser assists with the generation of a Course Plan. It should not be enacted until it is validated with the Student Advisor or Academic Chair of the Course.
 • This Course Plan is based on the course structure and offerings of latest Approved Courses only. It is the responsibility of students to ensure the correct availability of units in each semester/trimester of each academic year.
 • Please contact the Student Advisor if you have any queries relating to the Course Plan.
`.replace(/\n/g, '%0D%0A')
    },
    copyLink() {
      this.$refs.copyLinkUrl.focus()
      document.execCommand('copy')
    },
    mailtoLink() {
      this.emailLink = this.getBaseUrl + 'saved-plan?id=' + this.id
      console.log(this.emailLink)
    }
  },
  async mounted() {
    try {
      this.loading = true
      this.id = await this.storeCoursePlan()
      this.loading = false
      this.mailtoLink()
    } catch (ex) {
      this.loading = false
      this.error = true
    }
  }
}
</script>
<style></style>
